import { TipCard } from "@/components/cards/tip-card";
import { Loading } from "@uigovpe/components";
import { useCallback, useState } from "react";
import ProfileStepper from "./(components)/stepper";

export default function Perfil() {
  const [isLoading, setIsLoading] = useState(true);
  const handleLoadingChange = useCallback((loading: boolean) => {
    setIsLoading(loading);
  }, []);

  return (
    <main className="profile-page min-h-0! w-full! min-w-0! text-[#28272c]! md:p-5!">
      {isLoading && (
        <div
          className="flex min-h-[320px] w-full items-center justify-center"
          role="status"
          aria-live="polite"
          aria-label="Carregando perfil"
        >
          <Loading />
          <span className="sr-only">Carregando perfil...</span>
        </div>
      )}

      <div className={`${isLoading ? "hidden!" : "flex!"} w-full! gap-5!`}>
        <div className="min-w-0! flex-1! lg:flex-[2.3]!">
          <ProfileStepper onLoadingChange={handleLoadingChange} />
        </div>
        <aside className="hidden! flex-[0.7]! items-start! pt-[210px]! lg:flex!">
          <TipCard
            title="Dica para você"
            description="Seus dados ajudam a manter seu cadastro seguro e atualizado na plataforma."
          />
        </aside>
      </div>
    </main>
  );
}
